/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  ).toString();

class OpportunityAPI extends ApiClient {
  constructor() {
    super('opportunities', { accountScoped: true });
  }

  get({ page = 1, sort = 'name', stage, ownerId, companyId } = {}) {
    const requestURL = `${this.url}?${buildParams({
      page,
      sort,
      stage,
      owner_id: ownerId,
      company_id: companyId,
    })}`;
    return axios.get(requestURL);
  }

  getBoard({ stage, ownerId, companyId } = {}) {
    const requestURL = `${this.url}?${buildParams({
      board: true,
      stage,
      owner_id: ownerId,
      company_id: companyId,
    })}`;
    return axios.get(requestURL);
  }
}

export default new OpportunityAPI();
